import { useBrandName } from "../lib/company";

interface MockCardProps {
  size?: "sm" | "lg";
  className?: string;
}

/**
 * The card object — the ONLY dark thing in the app (DESIGN.md).
 * Deep teal-black, machined mono digits, stamped status.
 */
export const MockCard = ({ size = "lg", className = "" }: MockCardProps) => {
  const brandName = useBrandName();
  return (
    <div
      className={`card-shimmer rounded-[14px] bg-gradient-to-br from-[#12312C] via-card-obj to-[#071512] text-[#E8F5F2] shadow-[0_18px_40px_rgba(11,31,28,0.35)] ${
        size === "lg" ? "p-4" : "p-3.5"
      } aspect-[1.7/1] flex flex-col justify-between overflow-hidden relative ${className}`}
    >
      {/* Brand + status stamp */}
      <div className="flex justify-between items-start relative z-10">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-[#9DBDB6]">
            Virtual
          </p>
          <p className="text-sm font-semibold">{brandName} Card</p>
        </div>
        <span className="stamp text-[#9DBDB6]">Pending</span>
      </div>

      {/* Masked number — machined */}
      <p className="font-mono text-sm tracking-[0.14em] text-[#9DBDB6]/60 relative z-10">
        •••• •••• •••• ••••
      </p>

      {/* Balance + waiting line */}
      <div className="flex justify-between items-end relative z-10">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-[#9DBDB6]">
            Balance
          </p>
          <p className="money text-lg font-semibold text-[#E8F5F2]/70">$0.00</p>
        </div>
        <p className="font-mono text-[10px] text-[#9DBDB6]/70">AWAITING MINT</p>
      </div>
    </div>
  );
};
